var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTabStripe(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 378,
    height: 17,
    viewBox: "0 0 378 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.6 16.5L19.4413 16.5C18.7887 16.5 18.1771 16.1816 17.8028 15.6469L7.79715 1.35308C7.4229 0.818425 6.81132 0.500004 6.15869 0.500004L1.39876e-06 0.500004",
    stroke: "#1B2B38"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M352 16.5H25.6001",
    stroke: "#1B2B38"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M352 16.5L358.28 16.5C358.928 16.5 359.535 16.1866 359.91 15.6589L370.089 1.34114C370.465 0.813439 371.072 0.500001 371.72 0.500001L378 0.500001",
    stroke: "#1B2B38"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabStripe);
export default __webpack_public_path__ + "static/media/TabStripe.7190b729779291842655c9a3a64d8a87.svg";
export { ForwardRef as ReactComponent };